import { LORAX_LIGHT, OZ_LIGHT } from 'HubStyleTokens/colors';
export const IMAGE_BACKGROUND_OVERRIDES = {
  playbooks: LORAX_LIGHT,
  videoHostingManagement: OZ_LIGHT,
  bulkDuplicateManagement: OZ_LIGHT
};
export const ILLUSTRATIONS = {
  campaignManagement: 'qualify-leads',
  socialMedia: 'social',
  websiteTrafficAnalytics: 'traffic-analytics',
  seoAnalytics: 'content-strategy',
  omniChannelMarketingAutomation: 'workflows',
  sequences: 'sequences',
  forecasting: 'forecasting',
  prospectingWorkspace: 'sales-professional',
  salesAutomation: 'workflows',
  playbooks: 'playbooks',
  whatsAppIntegration: 'whatsapp',
  videoHostingManagement: 'successfully-submitted-question',
  knowledgeBase: 'knowledge-base',
  forms: 'forms',
  landingPages: 'call-to-action',
  customReports: 'add-on-reporting',
  dataQualityCommandCenter: 'operations-custom-mappings',
  programmableAutomation: 'workflows',
  bulkDuplicateManagement: 'contacts',
  dataQualityAutomation: 'bolt'
};